<template>
    <!-- Loja do Brasil: o mesmo campo de sempre, com a máscara que a tela já usava. -->
    <v-text-field
        v-if="brasil"
        ref="campo"
        v-bind="$attrs"
        v-on="ouvintes"
        v-mask="copiaDaMascara(mascaraBrasil)"
        :value="value"
        @input="$emit('input', $event)"
    />
    <!-- Loja de outro país: o cliente escolhe o país do número; máscara e DDI vêm de utils/paises.js. -->
    <v-text-field
        v-else
        ref="campo"
        :key="ddiAtual"
        v-bind="atributosExterior"
        v-on="ouvintes"
        v-mask="copiaDaMascara(paisAtual.telefone.mascara)"
        :value="value"
        :placeholder="paisAtual.telefone.exemplo"
        @input="$emit('input', $event)"
    >
        <template #prepend-inner>
            <v-menu offset-y>
                <template #activator="{ on, attrs }">
                    <v-btn
                        small
                        text
                        class="px-1 telefone-input__ddi"
                        :disabled="!!$attrs.disabled || $attrs.disabled === ''"
                        v-bind="attrs"
                        v-on="on"
                    >
                        +{{ ddiAtual }}
                        <v-icon small>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item v-for="p in paises" :key="p.codigo" @click="escolher(p)">
                        <v-list-item-title>{{ nomeDoPais(p) }} (+{{ p.ddi }})</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-text-field>
</template>

<script>
import { PAISES, isBrasil, pais, paisDoDdi } from '../utils/paises';

// Campo de WhatsApp com DDI (INTERNACIONALIZACAO_EUA_PLAN.md §4.1). Uso:
// <TelefoneInput v-model="telefone" :ddi.sync="telefoneDdi" label="WhatsApp" outlined dense />
export default {
    name: 'TelefoneInput',

    inheritAttrs: false,

    props: {
        value: { type: [String, Number], default: '' },
        ddi: { type: String, default: '' },
        mascaraBrasil: { type: [Array, String], default: () => ['(##) ####-####', '(##) #####-####'] },
    },

    computed: {
        brasil() {
            return isBrasil(this.$store.state.configuracoes?.pais);
        },

        ddiAtual() {
            return this.ddi || pais(this.$store.state.configuracoes?.pais).ddi;
        },

        paisAtual() {
            return paisDoDdi(this.ddiAtual);
        },

        paises() {
            return Object.values(PAISES);
        },

        // Fora do Brasil o "+55" e o exemplo brasileiro da tela não valem: o DDI fica no botão.
        atributosExterior() {
            // eslint-disable-next-line no-unused-vars
            const { prefix, placeholder, ...resto } = this.$attrs;
            return resto;
        },

        // O v-model já é tratado aqui; repassar o `input` do pai faria ele receber o valor duas vezes.
        ouvintes() {
            // eslint-disable-next-line no-unused-vars
            const { input, ...resto } = this.$listeners;
            return resto;
        },
    },

    watch: {
        brasil: {
            immediate: true,
            handler(brasil) {
                if (!brasil && !this.ddi) {
                    this.$emit('update:ddi', this.ddiAtual);
                }
            },
        },
    },

    methods: {
        // O vue-the-mask ordena o array de máscaras no próprio array (dynamic-mask.js). Com o array da prop,
        // que o Vue observa, cada ordenação avisava o render, que rodava a diretiva de novo: laço infinito,
        // e em produção (sem a trava do modo dev) a aba travava. A diretiva recebe sempre uma cópia.
        copiaDaMascara(mascara) {
            return Array.isArray(mascara) ? [...mascara] : mascara;
        },

        nomeDoPais(p) {
            const idioma = this.$i18n ? this.$i18n.locale : 'pt-BR';
            return p.nome[idioma] || p.nome['pt-BR'];
        },

        escolher(p) {
            if (p.ddi !== this.ddiAtual) {
                this.$emit('update:ddi', p.ddi);
                this.$emit('input', '');
            }
        },

        focus() {
            this.$refs.campo && this.$refs.campo.focus();
        },
    },
};
</script>

<style scoped>
.telefone-input__ddi {
    min-width: 0 !important;
    margin-top: -4px;
    text-transform: none;
}
</style>
